/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCreditOrderItemDTO interface.
 */
export function instanceOfWarehouseCreditOrderItemDTO(value) {
    return true;
}
export function WarehouseCreditOrderItemDTOFromJSON(json) {
    return WarehouseCreditOrderItemDTOFromJSONTyped(json, false);
}
export function WarehouseCreditOrderItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'asin': json['asin'] == null ? undefined : json['asin'],
        'title': json['title'] == null ? undefined : json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}
export function WarehouseCreditOrderItemDTOToJSON(json) {
    return WarehouseCreditOrderItemDTOToJSONTyped(json, false);
}
export function WarehouseCreditOrderItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'asin': value['asin'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'quantity': value['quantity'],
    };
}
